// import React from "react";
// import { Row, Col } from "react-bootstrap";
// import Sidebar from "./Sidebar";
// import TimelineHeader from "./TimelineHeader";
// import {
//   DndContext,
//   useSensor,
//   useSensors,
//   PointerSensor,
// } from "@dnd-kit/core";
// import { startOfDay, differenceInDays, addDays, format } from "date-fns";
// import ReservationBlock from "./ReservationBlock";
// import CalendarControls from "./CalendarControls";
// import RightSidebar from "../../Modals/RightSidebar";

// const CalendarGrid = ({
//   rooms,
//   reservations,
//   rateTypes,
//   currentDate,
//   setCurrentDate,
//   onUpdateReservation,
//   onAddReservation,
// }) => {
//   // Group rooms
//   const groupedRooms = React.useMemo(() => {
//     const groups = {};
//     rooms.forEach((room) => {
//       if (!groups[room?.room_type?.name]) groups[room?.room_type?.name] = [];
//       groups[room?.room_type?.name].push(room);
//     });
//     return Object.entries(groups);
//   }, [rooms]);

//   const [expandedGroups, setExpandedGroups] = React.useState(new Set());

//   // Initialize expanded groups
//   React.useEffect(() => {
//     setExpandedGroups(
//       new Set(groupedRooms.map(([room_type]) => room_type?.name))
//     );
//   }, [groupedRooms]);

//   const toggleGroup = (type) => {
//     const newSet = new Set(expandedGroups);
//     if (newSet.has(type)) {
//       newSet.delete(type);
//     } else {
//       newSet.add(type);
//     }
//     setExpandedGroups(newSet);
//   };

//   // Filter Logic
//   const [filter, setFilter] = React.useState("all");

//   const getRoomStatus = (roomId) => {
//     const todayStr = format(currentDate, "yyyy-MM-dd");
//     const reservation = reservations?.find(
//       (r) =>
//         r.room_id === roomId &&
//         r.check_in <= todayStr + "T23:59:59" &&
//         r.check_out >= todayStr + "T00:00:00"
//     );

//     if (!reservation) return "vacant";
//     if (reservation.status === "checked_in") return "occupied";
//     return "reserved";
//   };

//   const filteredGroupedRooms = groupedRooms; // Always show all rooms

//   // Helper to check if reservation matches filter
//   const shouldShowReservation = (reservation, filter) => {
//     if (filter === "all" || filter === "vacant") return true; // Show all for vacant to see gaps
//     if (filter === "occupied") return reservation.status === "checked_in";
//     if (filter === "reserved")
//       return (
//         reservation.status === "confirmed" ||
//         reservation.status === "payment_pending"
//       );
//     return true;
//   };

//   const counts = React.useMemo(() => {
//     let vacant = 0;
//     let occupied = 0;
//     let reserved = 0;
//     console.log(rooms);
//     rooms.forEach((room) => {
//       const status = getRoomStatus(room.id);
//       if (status === "vacant") vacant++;
//       else if (status === "occupied") occupied++;
//       else reserved++;
//     });

//     return {
//       all: rooms.length,
//       vacant,
//       occupied,
//       reserved,
//     };
//   }, [rooms, reservations, currentDate]);

//   const sensors = useSensors(
//     useSensor(PointerSensor, {
//       activationConstraint: {
//         distance: 8,
//       },
//     })
//   );

//   // Helper to check for overlaps
//   const checkOverlap = (roomId, start, end, excludeReservationId) => {
//     const startStr = format(start, "yyyy-MM-dd") + "T14:00:00.000000Z";
//     const endStr = format(end, "yyyy-MM-dd") + "T11:00:00.000000Z";

//     return reservations.some((r) => {
//       if (r.id === excludeReservationId) return false;
//       if (r.room_id !== roomId) return false;

//       // Check for overlap
//       // (StartA <= EndB) and (EndA >= StartB)
//       return startStr < r.check_out && endStr > r.check_in;
//     });
//   };

//   const handleDragEnd = (event) => {
//     const { active, delta } = event;
//     if (!active.data.current) return;

//     const reservation = active.data.current.reservation;
//     const daysMoved = Math.round(delta.x / 100);
//     const roomsMoved = Math.round(delta.y / 60);

//     if (daysMoved === 0 && roomsMoved === 0) return;

//     const currentRoomIndex = rooms.findIndex(
//       (r) => r.id === reservation.room_id
//     );
//     const newRoomIndex = currentRoomIndex + roomsMoved;

//     // Validate new room
//     if (newRoomIndex < 0 || newRoomIndex >= rooms.length) return;
//     const newRoom = rooms[newRoomIndex];

//     // Calculate new dates
//     const oldCheckIn = new Date(reservation.check_in);
//     const oldCheckOut = new Date(reservation.check_out);
//     const newCheckIn = addDays(oldCheckIn, daysMoved);
//     const newCheckOut = addDays(oldCheckOut, daysMoved);

//     // Check if new start date is in the past
//     if (newCheckIn < startOfDay(new Date())) {
//       alert("Cannot move reservation to a past date.");
//       return;
//     }

//     // Check for overlap
//     if (checkOverlap(newRoom.id, newCheckIn, newCheckOut, reservation.id)) {
//       alert("Cannot move reservation: Slot is already booked.");
//       return;
//     }

//     onUpdateReservation({
//       ...reservation,
//       room_id: newRoom.id,
//       check_in: format(newCheckIn, "yyyy-MM-dd") + "T14:00:00.000000Z",
//       check_out: format(newCheckOut, "yyyy-MM-dd") + "T11:00:00.000000Z",
//     });
//   };

//   // Sidebar State
//   const [sidebarState, setSidebarState] = React.useState({
//     isOpen: false,
//     mode: "add", // 'add' or 'details'
//     data: null, // reservation object or initial slot data
//   });

//   const handleReservationClick = (reservation) => {
//     setSidebarState({
//       isOpen: true,
//       mode: "details",
//       data: reservation,
//     });
//   };

//   const handleGridClick = (roomId, dayIndex) => {
//     const date = addDays(startOfDay(currentDate), dayIndex);
//     setSidebarState({
//       isOpen: true,
//       mode: "add",
//       data: {
//         roomId,
//         date: format(date, "yyyy-MM-dd"),
//       },
//     });
//   };

//   const handleAddBookingClick = () => {
//     setSidebarState({
//       isOpen: true,
//       mode: "add",
//       data: {},
//     });
//   };

//   const closeSidebar = () => {
//     setSidebarState((prev) => ({ ...prev, isOpen: false }));
//   };

//   return (
//     <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
//       <div className="d-flex justify-content-between align-items-center m-3">
//         <h4 className="mb-0">Calendar</h4>
//         <button className="btn btn-primary" onClick={handleAddBookingClick}>
//           + Add Booking
//         </button>
//       </div>

//       <div className="calendar-container border rounded m-3 overflow-hidden">
//         <CalendarControls
//           filter={filter}
//           setFilter={setFilter}
//           counts={counts}
//           currentDate={currentDate}
//           setCurrentDate={setCurrentDate}
//         />
//         <Row className="g-0">
//           <Col md={2} className="border-end">
//             <div
//               className="p-3 border-bottom fw-bold"
//               style={{ height: "50px" }}
//             >
//               Rooms
//             </div>
//             <Sidebar
//               groupedRooms={filteredGroupedRooms}
//               expandedGroups={expandedGroups}
//               onToggleGroup={toggleGroup}
//             />
//           </Col>
//           <Col md={10}>
//             <div
//               className="timeline-body position-relative"
//               style={{ overflowX: "auto" }}
//             >
//               <div style={{ width: `${14 * 100}px`, position: "relative" }}>
//                 <TimelineHeader currentDate={currentDate} />
//                 {filteredGroupedRooms.map(([type, groupRooms]) => (
//                   <React.Fragment key={type}>
//                     <div
//                       className="d-flex border-bottom"
//                       style={{ height: "50px", backgroundColor: "#ffe4e6" }}
//                     >
//                       {Array.from({ length: 14 }).map((_, i) => {
//                         const date = addDays(startOfDay(currentDate), i);
//                         const dateStr = format(date, "yyyy-MM-dd");
//                         const isToday =
//                           dateStr === format(new Date(), "yyyy-MM-dd");

//                         let availableCount = 0;
//                         let totalRevenue = 0;

//                         groupRooms.forEach((room) => {
//                           const isBooked = reservations?.some(
//                             (r) =>
//                               r.room_id === room.id &&
//                               r.check_in <= dateStr + "T23:59:59" &&
//                               r.check_out >= dateStr + "T00:00:00"
//                           );

//                           if (!isBooked) {
//                             availableCount++;
//                           } else {
//                             // Simplified revenue: room price
//                             totalRevenue += room.price;
//                           }
//                         });

//                         return (
//                           <div
//                             key={i}
//                             className="border-end d-flex flex-column justify-content-center align-items-center"
//                             style={{
//                               width: "100px",
//                               minWidth: "100px",
//                               backgroundColor: isToday
//                                 ? "rgba(59, 130, 246, 0.1)"
//                                 : "transparent",
//                             }}
//                           >
//                             <div className="fw-bold small">
//                               {availableCount}
//                             </div>
//                             <div
//                               className="small text-muted"
//                               style={{ fontSize: "10px" }}
//                             >
//                               {totalRevenue.toFixed(2)}
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>

//                     {expandedGroups.has(type) &&
//                       groupRooms.map((room) => (
//                         <div
//                           key={room.id}
//                           className="d-flex border-bottom position-relative"
//                           style={{ height: "50px" }}
//                         >
//                           {/* Grid lines */}
//                           {Array.from({ length: 14 }).map((_, i) => {
//                             const date = addDays(startOfDay(currentDate), i);
//                             const isToday =
//                               format(date, "yyyy-MM-dd") ===
//                               format(new Date(), "yyyy-MM-dd");
//                             return (
//                               <div
//                                 key={i}
//                                 className="border-end"
//                                 style={{
//                                   width: "100px",
//                                   height: "100%",
//                                   position: "absolute",
//                                   left: `${i * 100}px`,
//                                   top: 0,
//                                   cursor: "pointer",
//                                   backgroundColor: isToday
//                                     ? "rgba(59, 130, 246, 0.05)"
//                                     : "transparent",
//                                 }}
//                                 onClick={() => handleGridClick(room.id, i)}
//                                 title="Click to add booking"
//                               ></div>
//                             );
//                           })}

//                           {/* Reservations for this room */}
//                           {reservations
//                             ?.filter(
//                               (r) =>
//                                 r.room_id === room.id &&
//                                 shouldShowReservation(r, filter)
//                             )
//                             .map((reservation) => {
//                               const startDate = startOfDay(currentDate);
//                               const checkIn = new Date(reservation.check_in);
//                               const checkOut = new Date(reservation.check_out);

//                               const diffDays = differenceInDays(
//                                 startOfDay(checkIn),
//                                 startDate
//                               );
//                               const durationDays = differenceInDays(
//                                 startOfDay(checkOut),
//                                 startOfDay(checkIn)
//                               );

//                               // Only render if visible (simplified check)
//                               if (diffDays + durationDays < 0 || diffDays > 14)
//                                 return null;

//                               // Adjusted positioning: Start 25% into the day (25px offset)
//                               const left = diffDays * 100 + 25;
//                               const width = Math.max(durationDays * 100, 20); // Minimum width of 20px

//                               return (
//                                 <ReservationBlock
//                                   key={reservation.id}
//                                   reservation={reservation}
//                                   style={{
//                                     left: `${left}px`,
//                                     width: `${width}px`,
//                                   }}
//                                   onClick={() =>
//                                     handleReservationClick(reservation)
//                                   }
//                                   onResize={(newDuration) => {
//                                     const newCheckOut = addDays(
//                                       new Date(reservation.check_in),
//                                       newDuration
//                                     );

//                                     // Check for overlap
//                                     if (
//                                       checkOverlap(
//                                         reservation.room_id,
//                                         new Date(reservation.check_in),
//                                         newCheckOut,
//                                         reservation.id
//                                       )
//                                     ) {
//                                       alert(
//                                         "Cannot extend reservation: Slot is already booked."
//                                       );
//                                       return;
//                                     }

//                                     onUpdateReservation({
//                                       ...reservation,
//                                       check_out:
//                                         format(newCheckOut, "yyyy-MM-dd") +
//                                         "T11:00:00.000000Z",
//                                     });
//                                   }}
//                                 />
//                               );
//                             })}
//                         </div>
//                       ))}
//                   </React.Fragment>
//                 ))}
//               </div>
//             </div>
//           </Col>
//         </Row>
//         <Row className="g-0 border-top">
//           <Col md={2} className="border-end bg-light p-2 fw-bold">
//             <div>Room Availability</div>
//             <div className="mt-2">Occupancy(%)</div>
//           </Col>
//           <Col md={10}>
//             <div style={{ overflowX: "hidden" }}>
//               <div className="d-flex" style={{ width: `${14 * 100}px` }}>
//                 {Array.from({ length: 14 }).map((_, i) => {
//                   const date = addDays(startOfDay(currentDate), i);
//                   const dateStr = format(date, "yyyy-MM-dd");
//                   const isToday = dateStr === format(new Date(), "yyyy-MM-dd");

//                   // Calculate daily stats
//                   let totalRooms = rooms.length;
//                   let occupiedCount = 0;

//                   rooms.forEach((room) => {
//                     const isBooked = reservations?.some(
//                       (r) =>
//                         r.room_id === room.id &&
//                         r.check_in <= dateStr + "T23:59:59" &&
//                         r.check_out >= dateStr + "T00:00:00"
//                     );
//                     if (isBooked) occupiedCount++;
//                   });

//                   const availableCount = totalRooms - occupiedCount;
//                   const occupancyRate =
//                     totalRooms > 0
//                       ? Math.round((occupiedCount / totalRooms) * 100)
//                       : 0;

//                   return (
//                     <div
//                       key={i}
//                       className="border-end text-center p-2 fw-bold bg-light"
//                       style={{
//                         width: "100px",
//                         minWidth: "100px",
//                         backgroundColor: isToday
//                           ? "rgba(59, 130, 246, 0.1)"
//                           : undefined,
//                       }}
//                     >
//                       <div>{availableCount}</div>
//                       <div className="mt-2">{occupancyRate}</div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </div>

//       <RightSidebar
//         isOpen={sidebarState.isOpen}
//         onClose={closeSidebar}
//         mode={sidebarState.mode}
//         data={sidebarState.data}
//         onAddReservation={onAddReservation}
//         onUpdateReservation={onUpdateReservation}
//         rooms={rooms}
//         rateTypes={rateTypes}
//       />
//     </DndContext>
//   );
// };

// export default CalendarGrid;

import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Sidebar from "./Sidebar";
import TimelineHeader from "./TimelineHeader";
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import { startOfDay, differenceInDays, addDays, format } from "date-fns";
import ReservationBlock from "./ReservationBlock";
import CalendarControls from "./CalendarControls";
import RightSidebar from "../../Modals/RightSidebar";
import ReservationViewSidebar from "../../Modals/ReservationViewSidebar";

const CalendarGrid = ({
  calendarData,
  reservations,
  currentDate,
  setCurrentDate,
  onUpdateReservation,
  onAddReservation,
}) => {
  // ---------------------------------------------
  // 1️⃣ FLATTEN ROOMS FROM NEW API STRUCTURE
  // ---------------------------------------------
  const rooms = React.useMemo(() => {
    if (!calendarData?.room_types) return [];

    let list = [];

    calendarData.room_types.forEach((rt) => {
      rt.rooms.forEach((room) => {
        list.push({
          ...room,
          room_type: { id: rt.id, name: rt.name },
          rate_types: rt.rate_types,
        });
      });
    });

    return list;
  }, [calendarData]);

  const [hoverRow, setHoverRow] = useState(null);
  const [hoverCol, setHoverCol] = useState(null);

  const flatReservations = React.useMemo(() => {
    if (!reservations) return [];

    const list = [];

    reservations.forEach((res) => {
      res.rooms.forEach((sub) => {
        list.push({
          reservation_id: res.id,
          room_id: sub.room_id,
          guest_name: res.guest?.name,
          status: res.status,
          check_in: res.check_in,
          check_out: res.check_out,
          sub_reservation: sub,
          full_reservation: res,
        });
      });
    });

    return list;
  }, [reservations]);

  console.log(flatReservations);

  const roomTypes = React.useMemo(() => {
    if (!calendarData?.room_types) return [];

    return calendarData.room_types.map((rt) => ({
      id: rt.id,
      name: rt.name,
      base_price: rt.base_price,
      extra_adult_price: rt.extra_adult_price,
      extra_child_price: rt.extra_child_price,
    }));
  }, [calendarData]);

  // ---------------------------------------------
  // 2️⃣ FLATTEN RATE TYPES FROM NEW API
  // ---------------------------------------------
  const rateTypes = React.useMemo(() => {
    if (!calendarData?.room_types) return [];

    return calendarData.room_types.flatMap((rt) =>
      rt.rate_types.map((rate) => ({
        ...rate,
        room_type_id: rt.id,
      }))
    );
  }, [calendarData]);

  // ---------------------------------------------
  // GROUP ROOMS BY ROOM TYPE
  // ---------------------------------------------
  const groupedRooms = React.useMemo(() => {
    const groups = {};
    rooms.forEach((room) => {
      if (!groups[room.room_type.name]) groups[room.room_type.name] = [];
      groups[room.room_type.name].push(room);
    });
    return Object.entries(groups);
  }, [rooms]);

  const [expandedGroups, setExpandedGroups] = React.useState(new Set());

  React.useEffect(() => {
    setExpandedGroups(new Set(groupedRooms.map(([type]) => type)));
  }, [groupedRooms]);

  const toggleGroup = (type) => {
    const newSet = new Set(expandedGroups);
    newSet.has(type) ? newSet.delete(type) : newSet.add(type);
    setExpandedGroups(newSet);
  };

  // ---------------------------------------------
  // ROOM STATUS COUNTS
  // ---------------------------------------------
  const getRoomStatus = (roomId) => {
    const todayStr = format(currentDate, "yyyy-MM-dd");
    const res = reservations?.find(
      (r) =>
        r.room_id === roomId &&
        r.check_in <= todayStr + "T23:59:59" &&
        r.check_out >= todayStr + "T00:00:00"
    );

    if (!res) return "vacant";
    if (res.status === "checked_in") return "occupied";
    return "reserved";
  };

  const counts = React.useMemo(() => {
    let vacant = 0,
      occupied = 0,
      reserved = 0;

    rooms.forEach((room) => {
      const st = getRoomStatus(room.id);
      if (st === "vacant") vacant++;
      else if (st === "occupied") occupied++;
      else reserved++;
    });

    return {
      all: rooms.length,
      vacant,
      occupied,
      reserved,
    };
  }, [rooms, reservations, currentDate]);

  // ---------------------------------------------
  // DRAG & DROP
  // ---------------------------------------------
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } })
  );

  const checkOverlap = (roomId, start, end, excludeId) => {
    const s = format(start, "yyyy-MM-dd") + "T14:00:00.000000Z";
    const e = format(end, "yyyy-MM-dd") + "T11:00:00.000000Z";

    return reservations.some((r) => {
      if (r.id === excludeId) return false;
      if (r.room_id !== roomId) return false;
      return s < r.check_out && e > r.check_in;
    });
  };

  const handleDragEnd = (event) => {
    const { active, delta } = event;
    if (!active.data.current) return;

    const reservation = active.data.current.reservation;
    const daysMoved = Math.round(delta.x / 100);
    const roomsMoved = Math.round(delta.y / 60);

    if (daysMoved === 0 && roomsMoved === 0) return;

    const currentRoomIndex = rooms.findIndex(
      (r) => r.id === reservation.room_id
    );
    const newRoomIndex = currentRoomIndex + roomsMoved;

    if (newRoomIndex < 0 || newRoomIndex >= rooms.length) return;

    const newRoom = rooms[newRoomIndex];

    // calculate new dates
    const checkIn = addDays(new Date(reservation.check_in), daysMoved);
    const checkOut = addDays(new Date(reservation.check_out), daysMoved);

    if (checkIn < startOfDay(new Date())) {
      alert("Cannot move reservation to a past date.");
      return;
    }

    if (checkOverlap(newRoom.id, checkIn, checkOut, reservation.id)) {
      alert("Slot already booked.");
      return;
    }

    onUpdateReservation({
      ...reservation,
      room_id: newRoom.id,
      check_in: format(checkIn, "yyyy-MM-dd") + "T14:00:00.000000Z",
      check_out: format(checkOut, "yyyy-MM-dd") + "T11:00:00.000000Z",
    });
  };

  // ---------------------------------------------
  // SIDEBAR
  // ---------------------------------------------
  const [sidebarState, setSidebarState] = React.useState({
    isOpen: false,
    mode: "add",
    data: null,
  });

  const handleReservationClick = (reservation) => {
    setSidebarState({
      isOpen: true,
      mode: "details",
      data: reservation,
    });
  };

  const handleGridClick = (room, dayIndex) => {
    const date = addDays(startOfDay(currentDate), dayIndex);
    console.log(date);
    console.log(room);
    setSidebarState({
      isOpen: true,
      mode: "add",
      data: {
        room_id: room.id,
        room_type_id: room.room_type?.id,
        check_in: format(date, "yyyy-MM-dd"),
        check_out: format(addDays(date, 1), "yyyy-MM-dd"),
      },
    });
  };

  const closeSidebar = () => {
    setSidebarState((prev) => ({ ...prev, isOpen: false }));
  };

  // ---------------------------------------------
  // RENDER
  // ---------------------------------------------
  return (
    <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
      <div className="d-flex justify-content-between align-items-center m-3">
        <h4 className="mb-0">Calendar</h4>
        {/* <button
          className="btn btn-primary"
          onClick={() =>
            setSidebarState({ isOpen: true, mode: "add", data: {} })
          }
        >
          + Add Booking
        </button> */}
      </div>
      <div className="calendar-container border rounded m-3 overflow-hidden">
        <CalendarControls
          counts={counts}
          currentDate={currentDate}
          setCurrentDate={setCurrentDate}
        />

        <Row className="g-0">
          {/* LEFT SIDEBAR ROOM LIST */}
          <Col md={2} className="border-end">
            <div className="p-3 border-bottom fw-bold" style={{ height: 40 }}>
              Rooms
            </div>

            <Sidebar
              groupedRooms={groupedRooms}
              expandedGroups={expandedGroups}
              onToggleGroup={toggleGroup}
            />
          </Col>

          {/* TIMELINE GRID */}
          <Col md={10}>
            <div
              className="timeline-body position-relative"
              style={{ overflowX: "auto" }}
            >
              <div
                style={{
                  width: `${14 * 100}px`,
                  position: "relative",
                }}
              >
                <TimelineHeader currentDate={currentDate} />

                {groupedRooms.map(([type, groupRooms]) => (
                  <React.Fragment key={type}>
                    <div
                      className="d-flex border-bottom"
                      style={{ height: 40, backgroundColor: "#ffe4e6" }}
                    >
                      {Array.from({ length: 14 }).map((_, i) => {
                        console.log(i);
                        const date = addDays(startOfDay(currentDate), i);
                        const dateStr = format(date, "yyyy-MM-dd");
                        const isToday =
                          dateStr === format(new Date(), "yyyy-MM-dd");

                        let availableCount = 0;
                        let revenue = 0;

                        groupRooms.forEach((room) => {
                          const book = reservations?.some(
                            (r) =>
                              r.room_id === room.id &&
                              r.check_in <= dateStr + "T23:59:59" &&
                              r.check_out >= dateStr + "T00:00:00"
                          );
                          if (!book) availableCount++;
                          else revenue += room.rate || 0;
                        });

                        return (
                          <div
                            key={i}
                            className="border-end d-flex flex-column justify-content-center align-items-center"
                            style={{
                              width: 100,
                              backgroundColor: isToday
                                ? "rgba(59,130,246,.1)"
                                : "transparent",
                            }}
                          >
                            <div className="fw-bold small">
                              {availableCount}
                            </div>
                            <div
                              className="small text-muted"
                              style={{ fontSize: 10 }}
                            >
                              {revenue.toFixed(2)}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* ROOM ROWS */}
                    {expandedGroups.has(type) &&
                      groupRooms.map((room) => (
                        <div
                          key={room.id}
                          className="d-flex border-bottom position-relative"
                          style={{ height: 35 }}
                        >
                          {/* GRID BACKGROUND CELLS */}
                          {Array.from({ length: 14 }).map((_, i) => {
                            const date = addDays(startOfDay(currentDate), i);
                            const isToday =
                              format(date, "yyyy-MM-dd") ===
                              format(new Date(), "yyyy-MM-dd");

                            return (
                              <div
                                key={i}
                                className={`
    border-end
    ${hoverRow === room.id ? "hover-row" : ""}
    ${hoverCol === i ? "hover-col" : ""}
  `}
                                style={{
                                  width: 100,
                                  height: "100%",
                                  position: "absolute",
                                  left: `${i * 100}px`,
                                  cursor: "pointer",
                                  backgroundColor: isToday
                                    ? "rgba(59,130,246,.05)"
                                    : "transparent",
                                }}
                                onMouseEnter={() => {
                                  setHoverRow(room.id);
                                  setHoverCol(i);
                                }}
                                onMouseLeave={() => {
                                  setHoverRow(null);
                                  setHoverCol(null);
                                }}
                                onClick={() => handleGridClick(room, i)}
                              ></div>
                            );
                          })}

                          {/* RESERVATIONS */}
                          {flatReservations
                            ?.filter((r) => r.room_id === room.id)
                            .map((reservation) => {
                              const startDate = startOfDay(currentDate);
                              const checkIn = new Date(reservation.check_in);
                              const checkOut = new Date(reservation.check_out);

                              const diffDays = differenceInDays(
                                startOfDay(checkIn),
                                startDate
                              );
                              const durationDays = differenceInDays(
                                startOfDay(checkOut),
                                startOfDay(checkIn)
                              );

                              if (diffDays + durationDays < 0 || diffDays > 14)
                                return null;

                              const left = diffDays * 100 + 25;
                              const width = Math.max(durationDays * 100, 20);

                              return (
                                <ReservationBlock
                                  key={reservation.id}
                                  reservation={reservation}
                                  style={{
                                    left,
                                    width,
                                  }}
                                  onClick={() =>
                                    handleReservationClick(reservation)
                                  }
                                  onResize={(newDuration) => {
                                    const newCheckOut = addDays(
                                      checkIn,
                                      newDuration
                                    );

                                    if (
                                      checkOverlap(
                                        room.id,
                                        checkIn,
                                        newCheckOut,
                                        reservation.id
                                      )
                                    ) {
                                      alert("Slot already booked.");
                                      return;
                                    }

                                    onUpdateReservation({
                                      ...reservation,
                                      check_out:
                                        format(newCheckOut, "yyyy-MM-dd") +
                                        "T11:00:00.000000Z",
                                    });
                                  }}
                                />
                              );
                            })}
                        </div>
                      ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </Col>
        </Row>

        {/* FOOTER SUMMARY */}
        <Row className="g-0 border-top">
          <Col md={2} className="border-end bg-light p-2 fw-bold">
            <div>Room Availability</div>
            <div className="mt-2">Occupancy(%)</div>
          </Col>

          <Col md={10}>
            <div style={{ overflowX: "hidden" }}>
              <div className="d-flex" style={{ width: `${14 * 100}px` }}>
                {Array.from({ length: 14 }).map((_, i) => {
                  const date = addDays(startOfDay(currentDate), i);
                  const dateStr = format(date, "yyyy-MM-dd");
                  console.log(dateStr);
                  // const isToday = dateStr === format(new Date(), "yyyy-MM-dd");

                  let totalRooms = rooms.length;
                  let occupiedCount = 0;
                  console.log(totalRooms);
                  console.log(rooms);
                  console.log(reservations);

                  rooms.forEach((room) => {
                    const isBooked = reservations?.some(
                      (r) =>
                        r.room_id === room.id &&
                        r.check_in <= dateStr + "T23:59:59" &&
                        r.check_out >= dateStr + "T00:00:00"
                    );
                    if (isBooked) occupiedCount++;
                  });

                  const availableCount = totalRooms - occupiedCount;
                  const occupancyRate = totalRooms
                    ? Math.round((occupiedCount / totalRooms) * 100)
                    : 0;

                  return (
                    <div
                      key={i}
                      className="border-end text-center p-2 fw-bold bg-light"
                      style={{
                        width: 100,
                        // backgroundColor: isToday
                        //   ? "rgba(59,130,246,0.1)"
                        //   : undefined,
                      }}
                    >
                      <div>{availableCount}</div>
                      <div className="mt-2">{occupancyRate}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      {sidebarState.mode === "add" && (
        <RightSidebar
          isOpen={sidebarState.isOpen}
          onClose={closeSidebar}
          mode={sidebarState.mode}
          data={sidebarState.data}
          roomTypes={roomTypes}
          rooms={rooms}
          rateTypes={rateTypes}
          onAddReservation={onAddReservation}
          onUpdateReservation={onUpdateReservation}
        />
      )}
      {/* <ReservationViewSidebar
        isOpen={sidebarState.isOpen}
        data={sidebarState.data}
        onClose={() =>
          setSidebarState({
            isOpen: false,
            mode: "add",
            data: null,
          })
        } 
       onEdit={(res) => openEditSidebar(res)}
       /> */}
      {sidebarState.mode === "details" && (
        <ReservationViewSidebar
          isOpen={sidebarState.isOpen}
          data={sidebarState.data}
          onClose={() =>
            setSidebarState({
              isOpen: false,
              mode: "add",
              data: null,
            })
          }
        />
      )}
    </DndContext>
  );
};

export default CalendarGrid;
